import React, { Component } from 'react';
import Chart from 'react-apexcharts';
import { userStatus, envConfig, store } from '../../../_helpers';
import { Loader } from '../../../_components';
import { history } from '../../../_helpers';
import moment from 'moment';

export default class EventsChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      endpoint: this.props.endpoint,
      domain: this.props.parentDomain,
      raw_data: [],
      raw_labels: [],
      loaded: false,
      period: this.props.period,
      start: this.props.period.start,
      end: this.props.period.end,
      shouldShowChart: false,
      cardSize: 0,

      chartOptions: {},
      chartSeries: []
    }

    this.card = React.createRef();

    this.handleChartSwitch = this.handleChartSwitch.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  async componentDidMount() {
    this.listAnalyticsData(this.state.domain, this.state.start, this.state.end);
  }

  async componentWillReceiveProps(nextProps) {
    if ( nextProps.period.start === this.state.start && nextProps.period.end === this.state.end ) return;

    await this.setState({
      loaded: false,
      period: nextProps.period,
      start: nextProps.period.start,
      end: nextProps.period.end,
      domain: this.state.domain,
      chartOptions: {},
      chartSeries: []
    }, () => this.listAnalyticsData(this.state.domain, nextProps.period.start, nextProps.period.end));
  }

  handleResize = () => {
    if ( !this.card.current ) return;
    this.setState({cardSize: this.card.current.offsetWidth - 115});
  }

  async listAnalyticsData(domain, start, end) {
    const user = userStatus();
    const { endpoint } = this.state;

    if ( !domain ) domain = this.state.domain;
    if ( !start ) start = this.state.start;
    if ( !end ) end = this.state.end;

    const url = `${envConfig.ANALYTICS_API_URL}/analytics/${domain}${endpoint}?start=${start.format('YYYY-MM-DD')}&end=${end.format('YYYY-MM-DD')}`;
    const options = {
      method: "GET",
      headers: { Authorization: `Bearer ${user.bearer_token}` }
    }

    const request = await fetch(url, options);

    if ( request.status !== 200 ) {
      this.setState({loaded: true});
      return Promise.reject(await request.json());
    }

    let response = await request.json();
    if ( response.data.length === 0 ) return;

    let arr = {}
    const data = response.data.map(data => {
      if ( !arr[data.parent_category] ) {
        arr[data.parent_category] = [];
        
        return arr[data.parent_category].push({
          evento: data.parent_category,
          cliques: data.amount
        });
      }
      
      arr[data.parent_category][0].cliques += data.amount;
    });

    this.setState({loaded: true, raw_labels: Object.keys(arr), raw_data: arr});
  }

  async handleChartSwitch(e) {
    let user = userStatus();
    let parentCategory = e.target.getAttribute('data-event');

    if ( parentCategory === "return" ) return this.setState({shouldShowChart: false});

    this.setState({loaded: false, chartOptions: {}, chartSeries: []});

    const url = `${envConfig.ANALYTICS_API_URL}/analytics/event/${parentCategory}/${this.state.domain}/count/dailyPeopleImpacted?period=${this.state.period}`;
    const options = {
      method: "GET",
      headers: { Authorization: `Bearer ${user.bearer_token}` }
    }

    const request = await fetch(url, options);
    if ( request.status !== 200 ) {
      this.setState({loaded: true});
      return Promise.reject(await request.json());
    }

    let response = await request.json();
    if ( response.data.length === 0 ) return;

    let dates = [];
    let clicked = [];

    await response.data.map((data) => {
      let date = moment(data.date).format('DD/MM/YY');
      dates.push(date);
      clicked.push(data.amount);
    });

    let chartOptions = {
      chart: { id: `event-${parentCategory}` },
      xaxis: { categories: dates }
    }
    let chartSeries = [
      {
        name: "Disparos",
        data: clicked
      }
    ]

    if ( !this.card.current ) {
      return this.setState({chartOptions, chartSeries, loaded: true, shouldShowChart: true});
    }
    this.setState({chartOptions, chartSeries, loaded: true, shouldShowChart: true, cardSize: this.card.current.offsetWidth - 115});
  }

  render() {
    const { raw_data } = this.state;

    return (
      <div key={this.props.title} className={`col-xs-12 col-sm-12 col-md-${this.props.colsize} col-lg-${this.props.colsize}`}>
        <div className="card" ref={this.card} style={this.state.shouldShowChart ? {justifyContent: 'center', alignItems: 'center'} : {}}>
          <p className="title title-outside">{this.props.title}</p>

          {
            !this.state.shouldShowChart ?
              this.state.loaded ?
                this.state.raw_data && this.state.raw_labels ?
                  <div className="table-responsive table-responsive-height">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Evento</th>
                          <th title="Clicados"><i className="linearicons-mouse-left"></i></th>

                          {
                            this.state.period !== 1 ?
                              <th title="Gráfico"><i className="linearicons-graph"></i></th>
                            : null
                          }
                        </tr>
                      </thead>
                      <tbody>
                        {
                          this.state.raw_labels.length > 0 ?
                            this.state.raw_labels.map(label => {
                              return <tr>
                                <td>{raw_data[label][0].evento}</td>
                                <td>{raw_data[label][0].cliques}</td>

                                {
                                  this.state.period !== 1 ?
                                    <td><button className="btn btn-blue btn-icon btn-xs" data-event={raw_data[label][0].evento} onClick={this.handleChartSwitch}>Visualizar</button></td>
                                  : null
                                }
                                
                              </tr>
                            })
                          : null
                        }
                      </tbody>
                    </table>
                  </div>
                : null
              : <Loader className="is-blue" />
            : this.state.loaded ? <>
              <button onClick={this.handleChartSwitch} style={{marginLeft: "45px", marginRight: 0}} data-event="return" className="btn btn-blue btn-xs btn-icon"><i className="linearicons-arrow-left"></i></button>
              <Chart
                options={this.state.chartOptions}
                series={this.state.chartSeries}
                type="area"
                width={this.state.cardSize}
              />
            </> : <Loader className="is-blue" />

          }
        </div>
      </div>
    )
  }
}